module.exports = __webpack_public_path__ + "img/benefitIcon.09627ad4.svg";